// The browser transport: Stockfish's glue script as a Worker, UCI lines over
// postMessage. The glue finds its .wasm through the Worker's location hash.
import type { UciTransport } from '@chess/api-engine/uci';

export function createWorkerTransport(glueUrl: string, wasmUrl: string): UciTransport {
  const absoluteGlue = new URL(glueUrl, document.baseURI);
  const absoluteWasm = new URL(wasmUrl, document.baseURI).href;
  absoluteGlue.hash = encodeURIComponent(absoluteWasm);
  const worker = new Worker(absoluteGlue.href);
  const listeners = new Set<(line: string) => void>();
  worker.onmessage = (event: MessageEvent) => {
    if (typeof event.data !== 'string') return;
    for (const line of event.data.split('\n')) {
      if (line.length === 0) continue;
      for (const listener of listeners) listener(line);
    }
  };
  return {
    send: (line) => worker.postMessage(line),
    onLine(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    dispose() {
      worker.terminate();
      listeners.clear();
    },
  };
}
